module.exports = __webpack_public_path__ + "id_badge.47f0680f5c727db12d48e93fb0cea038.png";